function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1.99988 12.0002C1.99988 6.47803 6.47766 2.00024 11.9999 2.00024C17.5228 2.00024 21.9999 6.4777 21.9999 12.0002C21.9999 17.5228 17.5228 22.0002 11.9999 22.0002C6.47766 22.0002 1.99988 17.5225 1.99988 12.0002ZM20.4999 12.0002C20.4999 7.3061 16.6943 3.50024 11.9999 3.50024C7.30609 3.50024 3.49988 7.30646 3.49988 12.0002C3.49988 16.694 7.30609 20.5002 11.9999 20.5002C16.6943 20.5002 20.4999 16.6944 20.4999 12.0002ZM11.995 7.45434C12.3747 7.45434 12.6885 7.7365 12.7381 8.10257L12.745 8.20434V12.6233C12.745 13.0376 12.4092 13.3733 11.995 13.3733C11.6153 13.3733 11.3015 13.0912 11.2518 12.7251L11.245 12.6233V8.20434C11.245 7.79013 11.5808 7.45434 11.995 7.45434ZM12.755 15.7961C12.755 15.3819 12.4192 15.0461 12.005 15.0461L11.8932 15.053C11.5271 15.1027 11.245 15.4164 11.245 15.7961C11.245 16.2104 11.5808 16.5461 11.995 16.5461L12.1067 16.5393C12.4728 16.4896 12.755 16.1758 12.755 15.7961Z",
  fill: "#C65353"
});

function SvgUploadError(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadError);
export default __webpack_public_path__ + "static/media/upload-error.2b4d1811.svg";
export { ForwardRef as ReactComponent };